 <div class="ntp-settings" *ngIf="mustBePresented()">
    <div class="header">
      <div class="label">NTP time service</div>
      <div class="description" >Synchronize agent's time with this service</div>
    </div>

    <div class="ntp">
      <!-- automatically assign NTP service -->
      <div class="ntp-item">
        <div class="ntp-item-wrapper" [ngClass]="{'selected-ntp' : automaticNtpSelected}" (click)="selectAutomaticNtp()">
            <div class="ntp-icon" [ngClass]="{'selected-icon' : automaticNtpSelected}"><mat-icon>check_circle_outline</mat-icon></div>
          <div class="ntp-item-content">
            <div class="label">Automatically assign</div>
          </div>
        </div>
      </div>

      <!-- manual NTP server -->
      <div class="ntp-item">
        <div class="ntp-item-wrapper custom" [ngClass]="{'selected-ntp' : manualNtpSelected}" (click)="selectManualNtp()">
          <div class="ntp-icon" [ngClass]="{'selected-icon' : manualNtpSelected}">
            <mat-icon>check_circle_outline</mat-icon>
          </div>
          <div class="ntp-item-content">
              <div class="label">Manually assign</div>


          <form name="ntpAddressForm" *ngIf="manualNtpSelected" novalidate>
            <div class="group">
              <p>NTP server *</p>
              <input name="address"
                    autocomplete="off"
                    #addressInput="ngModel"
                    [(ngModel)]="address"
                    (ngModelChange)="updates()"
                    required
              />
              <div class="error" *ngIf="addressInput.invalid && (addressInput.dirty || addressInput.touched)">
                <mat-error *ngIf="addressInput.errors.required">NTP server name or address is required.</mat-error>
              </div>
            </div>
          </form>
          </div>
	      </div>
      </div>
    </div>
</div>
